import { PencilIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { getIconByName } from '../../../utils/iconMapping';

export default function ValueTag({
  value,
  onClick,
  showEditIcon = true,
  showDragHandle = false,
  dragHandleProps = null,
  variant: _variant = 'default', // 'default', 'compact', 'list'
  className = ''
}) {
  const hasCustomColor = value.color && value.color !== '#3B82F6';

  const colorStyle = hasCustomColor ? {
    backgroundColor: `${value.color}20`,
    borderColor: `${value.color}40`,
    borderWidth: '1px',
    color: value.color
  } : {};

  return (
    <motion.button
      onClick={onClick}
      className={`
        w-full text-left transition-all duration-200
        p-3 rounded-lg border
        ${hasCustomColor ? '' : 'bg-base-100 border-base-300 hover:border-primary hover:bg-base-50'}
        ${className}
      `}
      style={colorStyle}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
    >
      <div className="flex items-start justify-between gap-2">
        {/* Drag Handle */}
        {showDragHandle && (
          <div
            className="cursor-grab hover:bg-base-content/5 rounded p-1 -ml-1 flex-shrink-0"
            {...dragHandleProps}
          >
            <svg
              className="w-4 h-4 opacity-40"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <circle cx="7" cy="5" r="1.5" />
              <circle cx="7" cy="10" r="1.5" />
              <circle cx="7" cy="15" r="1.5" />
              <circle cx="13" cy="5" r="1.5" />
              <circle cx="13" cy="10" r="1.5" />
              <circle cx="13" cy="15" r="1.5" />
            </svg>
          </div>
        )}

        <div className="flex-1 min-w-0 flex items-center gap-2">
          {/* Icon */}
          {value.icon && (
            <div className="flex-shrink-0">
              {getIconByName(value.icon, "w-5 h-5")}
            </div>
          )}

          <div className="flex-1 min-w-0">
            <span className="font-medium block truncate">
              {value.name}
            </span>
            {value.description && (
              <p className="text-sm opacity-70 mt-1 line-clamp-2">
                {value.description}
              </p>
            )}
          </div>
        </div>
        {showEditIcon && (
          <PencilIcon className="w-4 h-4 opacity-40 flex-shrink-0 mt-1" />
        )}
      </div>
    </motion.button>
  );
}
